import React, { createRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Header from './Header'
import Footer from './Footer'
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import { Section, PageTitleOne, } from "master-react-lib";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
}));


export default function Tos() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <>
            <Header />

            <div className='InnerPageCtn'>
                <PageTitleOne
                    Title="Terms & Policies"
                    color="#fff"
                    backgroundcolor="#33B651"
                    height="100px"
                />

                <div className="privacy-plan-tabs">

                    <Tabs value={value} className="mt-5 terms-policy-tab" onChange={handleChange} aria-label="simple tabs example">
                        <Tab label="TERMS OF SERVICES" {...a11yProps(0)} />
                        <Tab label="PRIVACY POLICIES" {...a11yProps(1)} />
                    </Tabs>

                    <TabPanel value={value} index={0}>
                        <Container maxWidth="md" className="terms-content-container">
                            <div className='TosContentContainer'>
                                <h1>Who Helping Hand For Chittagonian</h1>
                                <p>This policy outlines the terms of service between you and “Helping Hand For Chittagonian Inc” or Helping Hand Chattogram-USA / HHC . This important agreement outlines several standard policies that allow us to run our website for you. If you have any questions about our terms of service, please contact us at  info@hhcusa.org or HelpCtg.usa@gmail.com
                                    <br></br>
                                    (a) The “Privacy Statement” refers to the privacy statement at https://hhcusa.org/terms-of-service
                                    <br></br>

                                    (b) “Terms and Conditions” refers to these Terms and Conditions, including the Privacy Policy as updated or amended from time to time.<br></br>
                                    (c) The “Website” refers individually and collectively to https://hhcusa.org and https://hhcusa.com<br></br>

                                    <b>US and International Terms of Service </b><br></br>
                                    This Terms of Service Agreement (the "Agreement") is between you ("you") and “Helping Hand For Chittagonian Inc” (together with our affiliates, service providers, and partners, “HHC,” "we," and/or "us") and governs your use of the https://hhcusa.org web site and successor web site(s) (the "Site"), including the materials and information posted on it, and the functionality that permits you to make donations, solicit donations, create an account, apply for a grant, establish fundraisers, solicit donations for a project, or to use any other functionality offered through the website.
                                    1. Acceptance of Terms and Supplementary Terms. “Helping Hand For Chittagonian Inc”  operates the Site subject to this Agreement, including the Privacy Policy and any additional guidelines, rules, terms and conditions, or limitations applicable to specific components of the Site (each, a "Supplementary Term"), each of which is incorporated by reference herein. In addition, Project Leaders, Non-Profit Organizations, and any Individual, Organization, or Company providing due diligence or application for a grant are subject to the terms and conditions set forth in the supplemental terms and conditions that are included with said application.By making a payment you acknowledge and agree that you are at least eighteen years of age, legally competent, and that you are entering into a legally binding contract with “Helping Hand For Chittagonian Inc”  governing your use of the Site, which contract includes all Supplementary Terms. If you are an individual accepting this Agreement on behalf of an agency or entity, you warrant that you have the legal right to accept this Agreement on behalf of such agency or entity and that the agency or entity will also be bound by this Agreement. You acknowledge and agree that Helping Hand For Chittagonian Inc retains control over the donated funds. In the event that (i) a project is retired or fully funded or (ii) Helping Hand For Chittagonian Inc, receives a check payable to Helping Hand For Chittagonian Inc, without reference to a specific project or campaign, the donated funds will be allocated to “Helping Hand For Chittagonian Inc’s General Fund. You acknowledge and agree that a printed version of this Agreement and/or any electronic communication from “Helping Hand For Chittagonian Inc” shall be admissible in judicial or administrative proceedings based upon or relating to this Agreement and/or your use of the Site to the same extent and subject to the same conditions as other business documents and records originally generated and maintained in printed form

                                </p>


                            </div>
                        </Container>
                    </TabPanel>

                    <TabPanel value={value} index={1}>
                        <Container maxWidth="md" className="terms-content-container">
                            <div className='TosContentContainer'>
                                <h1>Who Helping Hand For Chittagonian</h1>
                                <p>Helping Hand For Chittagonian uses its best efforts to respect the privacy of every individual who visits our website. As such, we have developed a rigorous privacy policy that reflects that respect. This notice explains our offline and online information privacy practices. Because your privacy is important to us, we provide you with notice and choices about the collection and use of your information.</p>

                            </div>
                        </Container>
                    </TabPanel>



                </div>
            </div >




            <Footer />
        </>
    )
}